import PermissionsApi from "./../api/permissionsApi";

export const GET_PERMISSIONS_DATA_REQUESTED =
  "permissions/GET_PERMISSIONS_DATA_REQUESTED";
export const GET_PERMISSIONS_DATA = "permissions/GET_PERMISSIONS_DATA";

const initialState = {
  data: {
    Dashboard: false,
    Fuel: false,
    Gas: false,
    Driving: false,
    EdicionDriving: false,
    EdicionTemp: false,
    ConsultaTemp: false,
    EdicionCan: false,
    ConsultaCan: false
  },
  isLoading: false,
  loadedPermissions: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PERMISSIONS_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_PERMISSIONS_DATA:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        loadedPermissions: true
      };

    default:
      return state;
  }
};

export const getPermissions = () => {
  return dispatch => {
    dispatch({
      type: GET_PERMISSIONS_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return PermissionsApi.getFakePermissions()
        .then(data => {
          dispatch({
            type: GET_PERMISSIONS_DATA,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    } else {
      return PermissionsApi.getPermissions()
        .then(data => {
          dispatch({
            type: GET_PERMISSIONS_DATA,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/permissions.js